module.exports = __webpack_public_path__ + "static/4-e84b2b9c85cefabdbdb59dc762c6d33e.png";